// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHoldDto } from './IHoldDto';
import {
    IHoldDtoFromJSON,
    IHoldDtoFromJSONTyped,
    IHoldDtoToJSON,
    IHoldDtoToJSONTyped,
} from './IHoldDto';

/**
 * 
 * @export
 * @interface ITransactionWorkflowPostingDto
 */
export interface ITransactionWorkflowPostingDto {
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    amount?: number;
    /**
     * 
     * @type {Set<IHoldDto>}
     * @memberof ITransactionWorkflowPostingDto
     */
    holds?: Set<IHoldDto>;
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    account_id: number;
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITransactionWorkflowPostingDto
     */
    invoice_posting_type?: string;
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    plan_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITransactionWorkflowPostingDto
     */
    policy_id?: number;
}

/**
 * Check if a given object implements the ITransactionWorkflowPostingDto interface.
 */
export function instanceOfITransactionWorkflowPostingDto(value: object): value is ITransactionWorkflowPostingDto {
    if (!('account_id' in value) || value['account_id'] === undefined) return false;
    return true;
}

export function ITransactionWorkflowPostingDtoFromJSON(json: any): ITransactionWorkflowPostingDto {
    return ITransactionWorkflowPostingDtoFromJSONTyped(json, false);
}

export function ITransactionWorkflowPostingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITransactionWorkflowPostingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'holds': json['holds'] == null ? undefined : (new Set((json['holds'] as Array<any>).map(IHoldDtoFromJSON))),
        'account_id': json['account_id'],
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_posting_type': json['invoice_posting_type'] == null ? undefined : json['invoice_posting_type'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
    };
}

export function ITransactionWorkflowPostingDtoToJSON(json: any): ITransactionWorkflowPostingDto {
    return ITransactionWorkflowPostingDtoToJSONTyped(json, false);
}

export function ITransactionWorkflowPostingDtoToJSONTyped(value?: ITransactionWorkflowPostingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'holds': value['holds'] == null ? undefined : (Array.from(value['holds'] as Set<any>).map(IHoldDtoToJSON)),
        'account_id': value['account_id'],
        'invoice_id': value['invoice_id'],
        'invoice_posting_type': value['invoice_posting_type'],
        'claim_id': value['claim_id'],
        'plan_id': value['plan_id'],
        'policy_id': value['policy_id'],
    };
}

